export class SearchDataActions {

  static FETCH_SAVED_CONFIGURATION_SEARCHES = "@FETCH_SAVED_CONFIGURATION_SEARCHES";
  static SAVED_CONFIGURATION_SEARCHES_LOADED = "@SAVED_CONFIGURATION_SEARCHES_LOADED";

  static DELETE_CONFIGURATION_SEARCH = "@DELETE_CONFIGURATION_SEARCH";  
  static SAVE_CONFIGURATION_SEARCH = "@SAVE_CONFIGURATION_SEARCH";  
}

